export default __webpack_public_path__ + "static/media/resource-desk-featured-image-placeholder.d37c4b72.svg";